import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './components/auth/login/login.component';
import {NgModule} from '@angular/core';
import {HomeComponent} from "./components/home/home.component";
import {AuthGuard} from "./services/auth.service";
import {ReservationsListComponent} from "./components/home/reservations-list/reservations-list.component";
import {MenuSetsListComponent} from "./components/home/menu-sets-list/menu-sets-list.component";
import {CalendarComponent} from "./components/home/calendar/calendar.component";
import {MenuSetDetailsComponent} from "./components/home/menu-set-details/menu-set-details.component";
import {ReservationDetailsComponent} from "./components/home/reservation-details/reservation-details.component";
import {PasswordResetRequestComponent} from "./components/auth/password-reset-request/password-reset-request.component";
import {PasswordResetConfirmComponent} from "./components/auth/password-reset-confirm/password-reset-confirm.component";

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'password-reset',
    component: PasswordResetRequestComponent
  },
  {
    path: 'password-reset/:uid/:token',
    component: PasswordResetConfirmComponent
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'reservations'
      },
      {
        path: 'reservations',
        component: ReservationsListComponent,
      },
      {
        path: 'reservations/:id',
        component: ReservationDetailsComponent,
      },
      {
        path: 'menus',
        component: MenuSetsListComponent,
      },
      {
        path: 'menus/:id',
        component: MenuSetDetailsComponent,
      },
      {
        path: 'calendar',
        component: CalendarComponent,
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class RoutingModule {
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/routing.module.ts